import { defineRouting } from "next-intl/routing";

/**
 * Define supported locales and routing behavior
 *
 * - Production: "as-needed" — default locale has no prefix (/about)
 * - Development: "always" — all locales prefixed (/en/about) to avoid
 *   root layout validation errors in Next.js dev mode
 */
export const routing = defineRouting({
  locales: ["en", "af"],
  defaultLocale: "en",
  localePrefix: process.env.NODE_ENV === "development" ? "always" : "as-needed",
  // Hreflang alternates are emitted once, as <link> tags via the Metadata API
  // (see lib/seo.ts `alternates.languages`). Disable next-intl's duplicate
  // `Link` response header so search engines don't see two hreflang sets.
  alternateLinks: false,
});

// Re-export types for convenience
export type Locale = (typeof routing.locales)[number];
export const locales = routing.locales;
export const defaultLocale = routing.defaultLocale;
